/**
 * Sustainability (Impact) READ endpoints — request schemas + wire types.
 *
 * Plain RLS-scoped reads (docs/BACKEND_API.md → "Read endpoints"): the Hono
 * handler queries the `sustainability_activity_index` view
 * (20260814071719 — a security_invoker slim projection of
 * carbon_emission_results) through the per-request user client, so org RLS
 * does the authorization. Template: expensesReads.ts.
 *
 * The wire interface is shared by the API handler (response construction)
 * and `useSustainabilityActivityIndex` (unwrap target) so the two sides
 * cannot drift.
 */
import { z } from "zod";
// ---------------------------------------------------------------------------
// Query-param schemas
// ---------------------------------------------------------------------------
/** Query params for GET /orgs/:orgId/activities/index. */
export const sustainabilityActivityIndexQuerySchema = z.object({
    /**
     * Scopes the index to one project via the view's `effective_project_id`
     * (COALESCE(cer.project_id, lt.project_id) — the canonical link
     * get_carbon_summary uses), serving the project Sustainability tab from
     * the same endpoint as the org-wide Impact page.
     */
    projectId: z.string().uuid().optional(),
});
//# sourceMappingURL=sustainabilityReads.js.map